var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useState } from 'react';
import { Alert, Checkbox } from '@one-thd/sui-atomic-components';
import { FormControlLabel, FormGroup } from '@material-ui/core';
import { ReturnError, ReturnCheckBoxError, ModalButtonGroup } from '../commons';
import { NationalAccountContext } from '../../../../../contexts';
import { modalBlurbs, shared } from '../../../../../constants/NationalAccount';
var GovtAffiliationDescription = function () {
    return (React.createElement("div", { className: "sui-rounded-md sui-px-4" },
        React.createElement(Alert, { status: "warning" },
            React.createElement("p", { "data-testid": "agreementHeader" }, modalBlurbs.governmentBlurbs.warning.line1),
            React.createElement("ul", { className: "sui-pl-4" },
                React.createElement("li", null, modalBlurbs.governmentBlurbs.warning.line2),
                React.createElement("li", null, modalBlurbs.governmentBlurbs.warning.line3)),
            modalBlurbs.governmentBlurbs.warning.line4)));
};
export var GovernmentAffiliationWarningModal = function () {
    var _a = useContext(NationalAccountContext), setValidResponseState = _a.setValidResponseState, errorState = _a.errorState, setErrorState = _a.setErrorState, setShowModal = _a.setShowModal;
    var _b = useState(false), isChecked = _b[0], setChecked = _b[1];
    var _c = useState(false), isCheckedErrorState = _c[0], setCheckedErrorState = _c[1];
    var handleChange = function (event) {
        if (!isChecked)
            setCheckedErrorState(false);
        setChecked(event.target.checked);
    };
    var cancelAgreement = function () {
        setErrorState(false);
        setShowModal(false);
        setValidResponseState(function (prevState) {
            return __assign(__assign({}, prevState), { enrollState: true, requiredEINState: false, einGovState: false });
        });
    };
    var validateResponse = function () {
        if (isChecked) {
            setValidResponseState(function (prevState) {
                return __assign(__assign({}, prevState), { einGovState: false });
            });
        }
        else {
            setErrorState(true);
        }
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-start sui-align-center sui-text-base" },
        React.createElement(GovtAffiliationDescription, null),
        React.createElement("div", null,
            React.createElement("div", { className: "sui-py-4 sui-px-2" },
                React.createElement(FormGroup, null,
                    React.createElement(FormControlLabel, { control: React.createElement("div", { style: { alignSelf: 'start' } },
                            React.createElement(Checkbox, { checked: isChecked, onChange: handleChange, size: "large" })), label: React.createElement("p", { className: "sui-text-base", style: { paddingTop: '2px' } }, modalBlurbs.governmentBlurbs.warning.line5) })),
                isCheckedErrorState && React.createElement(ReturnCheckBoxError, null)),
            errorState && React.createElement(ReturnError, null),
            React.createElement(ModalButtonGroup, { disabled: !isChecked, cb: validateResponse, confirmBlurb: shared.continue, handleClose: cancelAgreement, cancelBlurb: shared.cancel }))));
};
